import { LinkTypeEnum } from './enums';

export const LINK_TYPES = Object.values(LinkTypeEnum);
